import { Button, Empty, Flex, List, Space, Typography } from 'antd';
import PropTypes from 'prop-types';
import { formatNumber } from '@/common/utils/format';
import { getTopContentMetricTitle } from '../utils/analysis';
import { formatTraceAccountName } from '../utils/platform';

const AnalysisTopContentTable = ({
  dataSource,
  loading,
  metric,
  onHotRadarClick,
  onTrendClick,
}) => {
  const metricTitle = getTopContentMetricTitle(metric);
  return (
    <List
      dataSource={dataSource}
      locale={{ emptyText: <Empty description="暂无内容数据" /> }}
      renderItem={(content, index) => {
        const rankedTitle = `${index + 1}. ${content.title}`;
        return (
          <List.Item>
            <List.Item.Meta
              title={
                <Typography.Text strong ellipsis={{ tooltip: rankedTitle }}>
                  {rankedTitle}
                </Typography.Text>
              }
              description={
                <Flex justify="space-between" align="center" gap="small">
                  <Typography.Text type="secondary" ellipsis>
                    {formatTraceAccountName(content)} / {metricTitle} {formatNumber(content.value)}
                  </Typography.Text>
                  <Space.Compact>
                    <Button type="link" size="small" onClick={() => onTrendClick(content)}>
                      趋势
                    </Button>
                    <Button
                      type="link"
                      size="small"
                      loading={loading}
                      onClick={() => onHotRadarClick(content)}
                    >
                      拆解
                    </Button>
                  </Space.Compact>
                </Flex>
              }
            />
          </List.Item>
        );
      }}
      rowKey="id"
      size="small"
    />
  );
};

AnalysisTopContentTable.propTypes = {
  dataSource: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      accountId: PropTypes.string,
      contentId: PropTypes.string,
      platform: PropTypes.string,
      title: PropTypes.string,
      value: PropTypes.number,
    }),
  ),
  loading: PropTypes.bool,
  metric: PropTypes.string.isRequired,
  onHotRadarClick: PropTypes.func,
  onTrendClick: PropTypes.func,
};

AnalysisTopContentTable.defaultProps = {
  dataSource: [],
  loading: false,
  onHotRadarClick: () => {},
  onTrendClick: () => {},
};

export default AnalysisTopContentTable;
